import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTrailerPoolIdleQuickInfo extends Layout {
    panelInfo: Panel;
    sourceTrailerPool: DataSource;
    textboxDaysIdle: Textbox;
    textboxDestActualArrival: Textbox;
}
